import React from 'react';
import {
  Card,
  ListGroup,
} from "react-bootstrap";
import CompanyFAQMenuItem from './CompanyFAQMenuItem';

const CompanyFAQMenu = ({ title, items }) => {
  const handleScroll = (e, id) => {
    e.preventDefault();
    const targetElement = document.getElementById(id);

    if (targetElement) {
      const offset = 120;
      const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  return (
    <aside className="pe-xl-5 pe-lg-4">
      <Card className="border-0 mb-5 rounded-0">
        <Card.Header className="py-4 border-0 rounded-0" style={{ backgroundColor: '#F2FBF8' }}>
          <div className="d-flex align-items-center justify-content-between">
            <div>
              <h2 className="mb-0 h4">{title}</h2>
            </div>
          </div>
        </Card.Header>
        <ListGroup variant="flush" className="text-sm rounded-0">
          {items.map((item) => (
            <CompanyFAQMenuItem
              title={item.title}
              link={item.id}
              scroll={false}
              key={item.id}
              onClick={(e) => handleScroll(e, item.id)}
            />
          ))}
        </ListGroup>
      </Card>
    </aside>
  );
};

export default CompanyFAQMenu;
